import Service from './service'
export var ApiStatisticMessageType;
(function (ApiStatisticMessageType) {
  ApiStatisticMessageType["SYSTEM_STATISTIC"] = "system.statistic"
})(ApiStatisticMessageType || (ApiStatisticMessageType = {}))
/**
 * Сервис для работы со статистикой
 * @version 0.0.1
 * @since 1.9.0
 */
export default class StatisticService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
  }
  /**
     * Записать данные в csv-статистику
     * @since 1.9.0
     * @param {string} topic - название файла статистики
     * @param {Array<string>} data - данные для записи в файл
     * @memberof StatisticService
     *
     * @example <caption>Сохранить в файл</caption>
     * robot.statisticService.write(topic, data)
     */
  write(data, topic) {
    this.messageChannel.send({
      type: ApiStatisticMessageType.SYSTEM_STATISTIC,
      data: [`${ data }\n`],
      topic,
    })
  }
}
